module.exports = __webpack_public_path__ + "static/media/portfolio1 (52).980635ed.jpeg";